














































import { Vue, Component, Prop } from "vue-property-decorator";
import { Company as ICompany } from "@/api/models";
import CustomTable from "@/components/form/CustomTable.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import { Disk } from "@/api-v2/files/models";
import Modal from "@/components/form/Modal.vue";
import CField from "@/components/form/CField.vue";
import EditDiskForm from "@/components/admin/EditDiskForm.vue";
import api, { settingStorageApi } from "@/getinfo-api";
import { getCurrentCompanyId } from "@/plugins/roles";

@Component({
  components: {
    EditDiskForm,
    CField,
    Modal,
    CustomTableCol,
    CustomTableItem,
    CustomButton,
    CBlock,
    CustomTable
  }
})
export default class AdminControl extends Vue {
  @Prop() company!: ICompany;
  @Prop() disk!: Disk;
  isLimitChanged: boolean = false;
  studentLimit!: number;
  studentActiveAmount!: number;

  data() {
    return {
      studentLimit: undefined,
      studentActiveAmount: undefined
    };
  }

  get selectedCompany() {
    return getCurrentCompanyId();
  }

  changeLimit() {
    this.setLimit(+this.studentLimit);
  }

  setLimit(value: number) {
    settingStorageApi.Company.putCompanySettings(this.company.id, [
      { name: "studentLimit", value: { amount: value } }
    ]).then(() => {
      this.studentLimit = value;

      if (this.company.id === this.selectedCompany) {
        this.$store.state.studentLimit = value;
      }

      this.isLimitChanged = false;
      this.$bvToast.toast(`${this.$tc(this.$translate.Successful)}`, {
        variant: "success",
        title: `${this.$tc(this.$translate.Successful)}`
      });
    });
  }

  async getStudentLimit() {
    settingStorageApi.Company.getCompanySettings(this.company.id, [
      "studentLimit"
    ])
      .then(res => {
        //@ts-ignore
        this.studentLimit = res.data[0].value.amount;
      })
      .catch(() => {
        this.studentLimit = 1;
      });
  }
  async getStudentActive() {
    api.CourseApi.listenersCountGlobal(this.company.id).then(res => {
      this.studentActiveAmount = res.data;
    });
  }

  async init() {
    await this.getStudentActive();
    await this.getStudentLimit();
  }

  created() {
    this.init();
  }
}
